import { render } from "./NewsletterSubscriber.vue?vue&type=template&id=2d6c2f06&scoped=true"
import script from "../js/newsletter-subscriber.js?vue&type=script&lang=js"
export * from "../js/newsletter-subscriber.js?vue&type=script&lang=js"

import "./NewsletterSubscriber.vue?vue&type=style&index=0&id=2d6c2f06&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d6c2f06"]])

export default __exports__